module.exports = __webpack_public_path__ + "static/img/s.6ef5696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/relation/s.png
// module id = 4Ltq
// module chunks = 0